import { react2angular } from 'react2angular';
import { compose } from 'redux';

import app from '../../../browser/addform/scripts/app';
import { withProvider } from '../../redux';
import { withContext } from '../../utils/hoc/withContext';
import { DealSaleOfferLabel } from './DealSaleOfferLabel';

app.component(
  'cianAfDealSaleOfferLabel',
  react2angular(compose(withContext, withProvider)(DealSaleOfferLabel), [], ['config', 'httpApi', 'logger']),
);
